import { useState } from 'react';
import { locationIsKia } from '../../utils/helpers';
import Modal from './ui/Modal';
import WebComponentSnippet from './web-component-snippet';

interface Props {
  page: string;
  props?: string;
}

const Snippet = ({ page, props }: Props) => {
  const [includeFont, setIncludeFont] = useState(false);

  const jsSnippet = `<script
  type="module"
  src="https://kia-pages-cdn.vercel.app/prod/load.js"
></script>`;

  const kebabize = (str: string) =>
    str.replace(
      /[A-Z]+(?![a-z])|[A-Z]/g,
      ($, ofs) => (ofs ? '-' : '') + $.toLowerCase(),
    );

  const makeIntoDataProp = (props = '') => {
    if (!props) return '';

    return props
      .match(/([a-zA-ZäöåÄÖÅ-]+)="([^"]*)"/g) // Updated regex to capture everything within quotes
      .map((e) => {
        const [key, value] = e.split(/=(.+)/); // Split only at the first equals sign
        return `data-${kebabize(key)}=${value}`;
      })
      .join(' ');
  };

  const htmlSnippet = `<div id="kia-page" data-kia-page="${page}" ${makeIntoDataProp(props) ?? ''} ${includeFont ? 'data-include-font' : ''} ></div>`;

  const copySnippet = () => {
    navigator.clipboard.writeText(`${jsSnippet}\n${htmlSnippet}`);
  };

  const [showSnippet, setShowSnippet] = useState(false);

  return locationIsKia() ? null : (
    <>
      {showSnippet ? (
        <Modal clickOutside={() => setShowSnippet(false)}>
          <div className="bg-white p-4">
            <h2 className="text-center text-2xl">Kodsnutt</h2>
            <p className="text-center">
              Kopiera koden nedan och klistra in i ett frikodsblock
            </p>
            <p className="text-center">
              Scriptet ska endast laddas en gång per sida
            </p>
            <div className="flex items-center justify-between p-4 rounded-lg border mb-4">
              <div className="flex flex-col">
                <label
                  htmlFor="include-font"
                  className="text-sm font-medium cursor-pointer"
                >
                  Inkludera Kia typsnitt
                </label>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  id="include-font"
                  checked={includeFont}
                  onChange={(e) => setIncludeFont(e.target.checked)}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-black/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black"></div>
              </label>
            </div>
            <div className="bg-black p-4 text-white rounded-xl my-4">
              <pre className="text-sm">{jsSnippet}</pre>
            </div>
            <div className="bg-black p-4 text-white rounded-xl my-4 max-w-lg overflow-auto">
              <pre className="text-sm">{htmlSnippet}</pre>
            </div>
            <div className="flex justify-center gap-4">
              <button onClick={copySnippet} className="bg-black text-white p-2">
                Kopiera
              </button>
              <button
                onClick={() => setShowSnippet(false)}
                className="bg-black text-white p-2"
              >
                Stäng
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
      <button
        onClick={() => setShowSnippet(true)}
        className="z-10 fixed rounded-xl bg-black border-white border text-white p-2 bottom-2 right-2"
      >
        Visa kodsnutt
      </button>
      <WebComponentSnippet page={page} props={props} />
    </>
  );
};

export default Snippet;
